import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { Fab } from '@mui/material';

/**
 *
 * @param {string} backgroundColor
 * @param {function} onClick
 * @returns {JSX.Element}
 */
export default function VCardPreviewFloatingAddContactBtn({ backgroundColor, onClick }) {
  return (
    <Fab
      variant="circular"
      sx={{
        backgroundColor,
        position: 'sticky',
        bottom: 10,
        right: 10,
        alignSelf: 'end',
        color: 'white',
        width: 36,
        height: 36,
      }}
      onClick={onClick}
    >
      <PersonAddAlt1Icon sx={{ width: '16px', height: '16px' }} />
    </Fab>
  );
}
